<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#667eea" type="ball-clip-rotate-multiple" [fullScreen]="true"></ngx-spinner>
<router-outlet></router-outlet>
